const KLAVIYO_COMPANY_ID =
  process.env.REACT_APP_KLAVIYO_COMPANY_ID;

export function loadKlaviyo() {
  if (!KLAVIYO_COMPANY_ID) return;

  // Prevent double load (React 18 safe)
  if (document.getElementById("klaviyo-script")) return;

  const script = document.createElement("script");
  script.id = "klaviyo-script";
  script.async = true;
  script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${KLAVIYO_COMPANY_ID}`;

  document.body.appendChild(script);
}
